import { createFileRoute } from "@tanstack/react-router";
import { SuppliersPage } from "../../../../pages/suppliers-page/suppliers-page";

export const Route = createFileRoute("/_auth/_frame/suppliers/")({
  component: SuppliersPage,
});
